import { Alert, Box } from "@mui/material";

export default function AutocompleteOption() {
    return (
        <Box key="no_options" padding="0 8px">
            <Alert severity="warning">No options found</Alert>
        </Box>
    )
}